import type { AppAbility, PermissionTuple } from '~/utils/ability'
import {
  resolveMissingPermissions,
  type PermissionRequirement,
} from '~/utils/permissionRequirement'

/**
 * Décision d'autorisation d'un onglet, hors React : la règle de `useAuthorizedTabs`
 * (`utils/rbacTabs.tsx`), isolée pour être testable et partagée avec la palette de navigation
 * (⌘K), qui ne propose que les onglets que leur barre ouvre.
 */
/** Garde d'un onglet, étendue par `GuardedTab` (`utils/rbacTabs.tsx`). */
export interface TabGuard {
  /** Override explicite quand l'onglet n'a pas de route dédiée. */
  permission?: PermissionRequirement
}

export interface TabAuthorization {
  authorized: boolean
  missingPermissions: PermissionTuple[]
}

/** L'onglet est ouvert si sa permission v2 est déclarée et satisfaite. */
export const resolveTabAuthorization = (
  permission: PermissionRequirement | undefined,
  ability: AppAbility,
): TabAuthorization => {
  const missingPermissions = resolveMissingPermissions(ability, permission)
  const authorized = permission !== undefined && missingPermissions.length === 0

  return { authorized, missingPermissions }
}
